import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid, Typography, CircularProgress } from '@material-ui/core'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import InfoCard from 'src/components/InforCard/InfoCard'
import { PUBLISHED_STATUS } from 'src/components/NewsModule/constants'
import SearchInput from 'src/components/SearchInput/SearchInput'
import { getNotices } from 'src/services/api/WebApi/Notices/notices.service'
import { Notice } from 'src/services/api/WebApi/Notices/notices.types'
import { getNoticeCategory } from './constants'
import { useStyles } from './OpportunitiesContent.styles'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'

const OpportunitiesContent = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const [notices, setNotices] = useState<Notice[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        setIsLoading(true)
        const data = await getNotices()
        const publishedNotices = data.filter(
          (item) => item.status === PUBLISHED_STATUS
        )
        setNotices(publishedNotices)
      } catch (error) {
        console.error('Erro ao carregar editais:', error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchNotices()
  }, [])

  const getNoticeType = (notice: Notice) => {
    const title = notice.title?.trim().toLowerCase() || ''
    if (title.includes('clt')) return 'clt'
    if (title.includes('estágio') || title.includes('estagio')) return 'estágio'
    if (title.includes('bolsa')) return 'bolsa'
    return notice.type || notice.category || notice.categoryName || 'vaga'
  }
  return (
    <Box className={globalClasses.containerPages}>
      <Box className={globalClasses.topPageBreadcrumbsSearch}>
        <BreadcrumbsComponent
          crumbs={[
            { label: t('navbar.start'), path: '/' },
            { label: t('navbar.opportunities') }
          ]}
        />
        <SearchInput
          redirectUrl="/opportunities/search"
          placeholder={t('notices.search-placeholder')}
        />
      </Box>
      <Box className={classes.root}>
        <Typography variant="h3" className={globalClasses.titleSection}>
          {t('notices.page-title')}
        </Typography>
        <Box className={classes.content}>
          {isLoading ? (
            <Box display="flex" justifyContent="center" py={10}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={4}>
              {notices.length > 0 &&
                notices.map((notice) => {
                  const categoryConfig = getNoticeCategory(
                    getNoticeType(notice)
                  )

                  return (
                    <Grid item xs={12} sm={6} md={4} key={notice.id}>
                      <InfoCard
                        title={notice.title}
                        category={categoryConfig}
                        actionLabel={t('notices.view-more')}
                        link={`/opportunities/${notice.id}`}
                      />
                    </Grid>
                  )
                })}
            </Grid>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default OpportunitiesContent
